import { db } from "../dexie";
import { Task, TaskRecord, nullableUuid, taskRecordSchema } from "../types";
import { Collection } from "../utils/collection";

export const Tasks = {
  async getIncomplete() {
    const tasks = await db.tasks.where("completed").equals(0).sortBy("order");
    return tasks.map((t) => taskRecordSchema.encode(t));
  },
  getByParentId(parentId: string | null) {
    const dbParentId = nullableUuid.decode(parentId);
    return new Collection<Task, TaskRecord>(
      taskRecordSchema,
      db.tasks.where({ parentId: dbParentId }),
    );
  },
  /** Backlog tasks and subtrees assigned to a goal (`goalId` is the real goal id, not the null sentinel). */
  getByGoalId(goalId: string) {
    return new Collection<Task, TaskRecord>(
      taskRecordSchema,
      db.tasks.where("goalId").equals(goalId),
    );
  },
  getAll() {
    return new Collection<Task, TaskRecord>(taskRecordSchema, db.tasks.orderBy("order"));
  },
};
